import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { Observable } from "rxjs";
import { ICustomerRedeems } from "../../master-models/customer-redeem.model";

@Injectable()
export class CustomerRedeemService {
  url = `${environment.apiBaseUrl}api/customer_redeems`;

  constructor(private http: HttpClient) {}

  getRedeems(customerId: number): Observable<{success: boolean, data: ICustomerRedeems[]}> {
    return this.http.get<{success: boolean, data: ICustomerRedeems[]}>(`${this.url}/${customerId}`, {
      headers: this.getHeaders(),
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/customer-redeem/customer-redeem.service.ts